import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2484326a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484326a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2484326a')) {
      api.createRecord('2484326a', component.options)
    } else {
      api.reload('2484326a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2484326a&scoped=true", function () {
      api.rerender('2484326a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/goodsAll/index.vue"
export default component.exports